export const COMPANY_SETTINGS_PREFIX = 'company_settings_';

export const defaultCompanySettings = {
  company_id: '',
  company_name: 'Quote 2 Sales',
  company_address: '',
  company_city: '',
  company_phone: '',
  company_email: '',
  company_gst_no: '',
  company_currency: 'INR',
  company_tax_percentage: '18',
  company_note: '',
};

export const getCompanySettingsStorageKey = (companyId) => `${COMPANY_SETTINGS_PREFIX}${companyId || 'default'}`;

export const getCompanySettings = (companyId = '') => {
  const key = getCompanySettingsStorageKey(companyId);

  try {
    const raw = localStorage.getItem(key);
    if (!raw) return { ...defaultCompanySettings, company_id: companyId };

    const parsed = JSON.parse(raw);
    return { ...defaultCompanySettings, company_id: companyId, ...parsed };
  } catch (error) {
    return { ...defaultCompanySettings, company_id: companyId };
  }
};

export const saveCompanySettings = (companyId = '', settings = {}) => {
  const nextSettings = { ...defaultCompanySettings, company_id: companyId, ...settings };
  localStorage.setItem(getCompanySettingsStorageKey(companyId), JSON.stringify(nextSettings));
  return nextSettings;
};
